<div class="slide ">
    <div class="">
        <div class="column-left" style="overflow:hidden;">
            <msc-heading-actions>
                <h2 class="heading heading_border_none">
                    <div class="flex items-start justify-between gap-4">
                        <div class="flex items-start flex-col justify-between gap-4">
                            <div class="inline-flex  items-center gap-1.5 px-3 py-1 rounded-full text-xs uppercase font-normal"
                                style="background: color-mix(in srgb, var(--v2-color-secondary-400), white 92%); color: var(--v2-color-secondary-500);">
                                <span class="w-1.5 h-1.5 rounded-full mb-0"
                                    style="background: var(--v2-color-secondary-500);"></span>
                             {{ 'player.exchange.name'| translate }}
                            </div>
                            <span class="text-gray-700 text-md mb-0">{{ sectionContent.title || ('player.common.untitled' |
                                translate) }}</span>
                        </div>

                    </div>
                </h2>
            </msc-heading-actions>

            <p *ngIf="sectionContent.description" class="multiline"
                [innerHTML]="sectionContent?.description | safe:'html'"></p>
            <media-holder *ngIf="exchange.media" [media]="exchange?.media"></media-holder>
            <!-- <app-timeline *ngIf="exchange" (interactionEmitter)="updateExchange()" [context]="'exchange'" [contextId]="exchange?.id"></app-timeline>-->
            <msc-next-prev-btn></msc-next-prev-btn>
        </div>
    </div>
</div>
<div class="p-4">

    <div class="mx-4 bg-white border border-[#E8EAEF] rounded-2xl overflow-hidden pb-3 px-4">
        <app-timeline *ngIf="exchange" (interactionEmitter)="updateExchange()" [context]="'exchange'"
            [contextId]="exchange?.id"></app-timeline>
    </div>
</div>
<app-timer [timerService]="timerService" (close)="timerInit()"></app-timer>

<style>
    /*   @media only screen and (min-width: 320px) {
        .slide {
            margin: 1rem 0 0.5rem;
            width: 100%;
        }
    }*/
    /*
    @media only screen and (min-width: 768px) {
        .slide {
            margin: 8rem 0 1.5rem;
            width: 100%;
        }
    }*/
</style>